<script>
import getSecret from "@utils/get-secret";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import BaseDatatable from "@components/base-datatable";
import {
  euroCouponsIssueMethods,
  euroCouponsTutorialMethods,
  euroHabeasDataReportsManagement,
  captacionMethods,
} from "@state/helpers";
import ThirdpartyMultiselect from "@components/euro_coupons/thirdparty/Select";
import CustomDatePickerRange from "@components/CustomDatePickerRange";
import CustomMultiselect from "@/src/components/CustomMultiselect.vue";
import FormSelect from "@/src/components/form/Select.vue";
import SelectMultipleSearch from "@/src/components/form/SelectMultipleSearch.vue";
import downloadModal from "@/src/components/reports/management/modalDownload.vue";
import ActionButton from "@components/buttons/ActionButton.vue";
import ModalDetail from "@/src/components/reports/management/modalDetail.vue";

export default {
  name: "Reportes",
  page: {
    title: "Reportes",
    meta: [{ name: "Reportes", content: getSecret("DESCRIPTION") }],
  },
  components: {
    Layout,
    PageHeader,
    BaseDatatable,
    ThirdpartyMultiselect,
    CustomDatePickerRange,
    CustomMultiselect,
    FormSelect,
    downloadModal,
    ActionButton,
    ModalDetail,
    SelectMultipleSearch,
  },
  data() {
    return {
      title: this.$t("Reportes"),
      items: [
        {
          text: this.$t("home"),
          href: "/",
        },
        {
          text: this.$t("Reportes"),
          active: true,
        },
      ],

      reasonsOptions: [
        { label: "Redención duplicada.", value: 1 },
        { label: "Factura genérica.", value: 2 },
        { label: "El valor no concuerda.", value: 3 },
        { label: "Documento Invalido.", value: 4 },
        { label: "Más de un bono disponible.", value: 5 },
        { label: "Bono sin factura asociada.", value: 6 },
        { label: "Bono no encontrado en Siesa.", value: 7 },
      ],
      loadingReport: false,
      tableHeaders: [],
      toDetail: {},
      showDetail: false,
      filterset: null,
      filters: {
        CO: null,
        Caja: null,
        casherRegister__in: null,
        fecha__date__gte: null,
        fecha__date__lte: null,
      },
      x: null,
      cash_query: {
        key: "store_code",
        value: "",
      },
      showDownload: false,
    };
  },

  mounted() {
    this.setShowTutorial(true);
    this.setTutorialUrl("reporte_habeas");
    this.CashOptions();
  },

  destroyed() {
    this.setShowTutorial(false);
  },

  beforeMount() {
    this.tableHeaders = [
      { key: "co", label: this.$t("CO") },
      { key: "atmcode", label: this.$t("Código del cajero") },
      { key: "name_casher", label: this.$t("Nombre del vendedor") },
      { key: "compliance", label: this.$t("Cumplimiento") },
      { key: "actions", label: this.$t("Acciones") },
    ];
  },

  watch: {
    filters: {
      deep: true,
      handler(filters) {
        let filters_list = [];
        for (let filter in filters) {
          if (filters[filter]) {
            filters_list.push(`${filter}=${filters[filter]}`);
          }
        }
        if (filters_list.length) {
          this.filterset = filters_list.join("&");
        }
        this.filter();
      },
    },
  },

  methods: {
    ...euroCouponsIssueMethods,
    ...euroCouponsTutorialMethods,
    ...euroHabeasDataReportsManagement,
    ...captacionMethods,
    myProvider(ctx) {
      let context = this;
      ctx = context.$table_params(ctx);
      ctx += context.filterset ? `&${context.filterset}` : "";
      const promise = context.fetchReportManagement(ctx);
      return promise
        .then((data) => {
          return data;
        })
        .catch((error) => {
          context.$axios_error_noty(error, context);
          console.log(error);
          return [];
        });
    },
    setFilter(filter, value) {
      this.filters[filter] = value;
      console.log(value);
      if (filter == "CO") {
        this.cash_query = {
          key: "filter_cod",
          value: "",
        };
        this.filters.casherRegister__in = null;
      }
      if (filter == "x") {
        this.x = value;
        console.log(this.x);
        let arrayTemp = this.x;
        let arrayTemp2 = [];
        for (let register of arrayTemp) {
          arrayTemp2.push(register.id);
        }
        console.log(arrayTemp2);
        this.filters.casherRegister__in = arrayTemp2;
        if (this.filters.casherRegister__in.length == 1) {
          this.filters.casherRegister__in.push("xxxx");
        }
      }
    },

    filter() {
      this.$refs.table.lastFilter = "";
      this.$refs.table.onFiltered();
      setTimeout(() => this.$refs.table.refresh(), 200);
    },

    clear() {
      this.x = null;
      this.filters.CO = null;
      this.filters.Caja = null;
      this.filters.casherRegister__in = null;
      this.filters.fecha__date__gte = null;
      this.filters.fecha__date__lte = null;
      this.filterset = null;
      setTimeout(() => this.$refs.table.refresh(), 200);
    },
    getReport() {
      let _ = this;
      _.loadingReport = true;
      let query = `get_general_report/?fecha__date__lte=${this.filters.fecha__date__lte}&fecha__date__gte=${this.filters.fecha__date__gte}&CO=${this.filters.CO}`;
      const promise = _.fetchReportManagementExcel({
        query: query,
        type: { responseType: "arraybuffer" },
      });
      return promise
        .then((response) => {
          const data = response.data;
          const url = URL.createObjectURL(
            new Blob([data], {
              type: "application/vnd.ms-excel",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `Reporte de Habeas Data.xlsx`);
          document.body.appendChild(link);
          link.click();
          _.loadingReport = false;
        })
        .catch((error) => {
          _.loadingReport = false;
          console.error(error);
          _.$axios_error_noty("Se presento un error en la descarga del archivo.");
        });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-container fluid class="p-0">
      <b-row>
        <b-col>
          <b-card class="shadow-sm">
            <b-row class="text-primary px-2 mb-2" style="font-size: 16px">
              <b>{{ $t("filters") }}</b>
            </b-row>
            <b-row>
              <b-col md="3" class="p-0" style="margin: 0 1rem 0 0">
                <b-col>
                  <CustomDatePickerRange
                    :label="'date'"
                    :value_start="filters.fecha__date__gte"
                    :value_end="filters.fecha__date__lte"
                    @input_start="(value) => setFilter('fecha__date__gte', value)"
                    @input_end="(value) => setFilter('fecha__date__lte', value)"
                  />
                </b-col>
              </b-col>
              <b-col md="3" class="p-0" style="margin: 0 1rem 0 1rem">
                <FormSelect
                  :value="filters.CO"
                  :label="$t('Centro de operación')"
                  :fetchOptions="fetchCoOptions"
                  :drfProvider="true"
                  v-if="filters.fecha__date__gte && filters.fecha__date__lte"
                  @input="(value) => setFilter('CO', value)"
                  :withOutBorder="true"
                  :search="true"
                />
              </b-col>
              <b-col md="3" class="p-0" style="margin: 0 1rem 0 1rem">
                <SelectMultipleSearch
                  :value="x"
                  :label="$t('Código de Cajero')"
                  :fetchOptions="fetchCashRegisterOptions"
                  :drfProvider="true"
                  :reqParams="cash_query"
                  v-if="filters.CO"
                  :key="filters.CO"
                  :multiple="true"
                  @input="(value) => setFilter('x', value)"
                  :withOutBorder="true"
                  :search="true"
                >
                </SelectMultipleSearch>
              </b-col>

              <b-col md="1" class="ml-auto pt-3 pr-1 mt-1">
                <!-- <b-button
                  class="ml-1 rounded shadow-sm float-right"
                  variant="outline-primary"
                  @click="filter"
                  ><i class="fas fa-filter"></i>
                </b-button> -->
                <b-button
                  class="rounded shadow-sm float-right"
                  variant="outline-primary"
                  @click="clear"
                  ><i class="fas fa-eraser"></i>
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card class="shadow">
            <BaseDatatable
              ref="table"
              :drfprovider="myProvider"
              :tableheaders="tableHeaders"
              v-if="filters.CO"
              :key="filters.CO && filters.fecha__date__gte && filters.fecha__date__lte"
            >
              <template v-slot:buttons>
                <!-- <b-button variant="outline-primary rounded-lg  mx-1" :disabled="loadingReport" @click="getReport">

                  <b-spinner v-if="loadingReport" small label="Spinning"></b-spinner>
                  <i v-else class="fas fa-download"></i>
                </b-button> -->
                <b-button variant="outline-primary rounded-lg  mx-1" @click="getReport">
                  <b-spinner v-if="loadingReport" small label="Spinning"></b-spinner>
                  <i v-else class="fas fa-download"></i>
                </b-button>
              </template>

              <template v-slot:cell(co)="row">
                <p>{{ row.item.CO }}</p>
              </template>
              <template v-slot:cell(atmcode)="row">
                <p>{{ row.item.casherRegister }}</p>
              </template>
              <template v-slot:cell(name_casher)="row">
                <p>{{ row.item.name_casher }}</p>
              </template>
              <template v-slot:cell(compliance)="row">
                <div style="margin-top: -1rem">
                  <p
                    class="m-0 p-0"
                    :id="`active-div-${row.index}`"
                    v-if="row.item.compliance >= 0 && row.item.compliance <= 100"
                  >
                    {{ row.item.compliance }}%
                  </p>
                  <p
                    class="m-0 p-0"
                    :id="`active-div-${row.index}`"
                    v-if="row.item.compliance > 100"
                  >
                    {{ 100 }}%
                  </p>
                </div>
              </template>

              <template v-slot:cell(actions)="row">
                <b-button-group size="xs">
                  <b-button
                    :id="`info-btn-${row.index}`"
                    v-b-tooltip.hover="{
                      variant: 'info',
                      placement: 'leftbottom',
                      title: $t('detail'),
                    }"
                    variant="btn-link text-info btn-transparent"
                    size="xs"
                    @click="
                      () => {
                        showDetail = true;
                        toDetail = row.item;
                      }
                    "
                  >
                    <i class="fe-info fe-2x"></i>
                  </b-button>

                  <!-- <b-button
                    :id="`update-btn-${row.index}`"
                    v-b-tooltip.hover="{
                      variant: 'warning',
                      placement: 'leftbottom',
                      title: $t('edit'),
                    }"
                    variant="btn-link text-warning btn-transparent"
                    size="xs"
                    @click="()=>{showForm=true; toUpdate=row.item}"
                  >
                    <i class="fe-edit fe-2x"></i>
                  </b-button>

                  <b-button
                    :id="`delete-btn-${row.index}`"
                    v-b-tooltip.hover="{
                      variant: 'danger',
                      placement: 'leftbottom',
                      title: $t('delete'),
                    }"
                    variant="btn-link text-danger btn-transparent"
                    size="xs"
                    @click="()=>{showDelete=true; toDelete=row.item}"
                  >
                    <i class="fe-x fe-2x"></i>
                  </b-button> -->
                </b-button-group>
              </template>
            </BaseDatatable>
          </b-card>
        </b-col>
      </b-row>
    </b-container>

    <ModalDetail
      v-if="showDetail"
      :instanceJson="toDetail || {}"
      :oncomplete="
        () => {
          showDetail = false;
          toDetail = {};
        }
      "
      :oncancel="
        () => {
          showDetail = false;
          toDetail = {};
        }
      "
    ></ModalDetail>

    <downloadModal
      v-if="showDownload"
      :filters="filters"
      :loadingReport="loadingReport"
    ></downloadModal>
  </Layout>
</template>
